export function isKnockoutReleased(): boolean {
  return import.meta.env.VITE_KNOCKOUT_ENABLED === 'true';
}
